import React, { useEffect, useState } from "react";

const days = ["Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek"];

const DailyMenuTabs = () => {
  const today = new Date().getDay();
  const initialDay = today >= 1 && today <= 5 ? days[today - 1] : "";

  const [selectedDay, setSelectedDay] = useState(initialDay);
  const [menuList, setMenuList] = useState([]);
  const [sidesList, setSidesList] = useState([]);
  const [notesList, setNotesList] = useState([]);

  const dayFileMap = {
    Pondělí: "pondeli",
    Úterý: "utery",
    Středa: "streda",
    Čtvrtek: "ctvrtek",
    Pátek: "patek",
  };

  const isWeekend = selectedDay === "";

  const loadMenu = (day) => {
    setSelectedDay(day);
    const filename = dayFileMap[day];

    fetch(`/documents/${filename}.json`)
      .then((res) => {
        if (!res.ok) throw new Error(`Soubor ${filename}.json nenalezen`);
        return res.json();
      })
      .then((data) => {
        setMenuList(Array.isArray(data.menu) ? data.menu : []);
      })
      .catch(() => {
        setMenuList(["Menu nelze načíst."]);
      });
  };

  useEffect(() => {
    fetch("/documents/prilohy.json")
      .then((res) => {
        if (!res.ok) throw new Error("Soubor prilohy.json nenalezen");
        return res.json();
      })
      .then((data) => {
        setSidesList(Array.isArray(data.sides) ? data.sides : []);
        setNotesList(Array.isArray(data.poznamky) ? data.poznamky : []);
      })
      .catch(() => {
        setSidesList([]);
        setNotesList([]);
      });
  }, []);

  useEffect(() => {
    if (selectedDay) {
      loadMenu(selectedDay);
    }
  }, [selectedDay]);

  const formatWithPriceHighlight = (text) => {
    const match = text.split("–");
    if (match.length >= 2) {
      return (
        <>
          {match[0].trim()} – <span className="font-semibold text-red-600">{match.slice(1).join("–").trim()}</span>
        </>
      );
    }
    return text;
  };

  return (
    <div className="max-w-6xl mx-auto px-6 py-12 border-b border-red-200">
      <h2 className="text-2xl font-semibold text-red-700 mb-6 border-l-4 border-red-600 pl-3">Denní menu</h2>

      <div className="flex flex-col md:flex-row gap-6">
        {/* Levý sloupec s dny */}
        <div className="w-full md:w-1/4">
          <ul className="space-y-2">
            {days.map((day) => (
              <li key={day}>
                <button
                  onClick={() => loadMenu(day)}
                  className={`w-full text-left px-4 py-2 rounded-md text-sm font-semibold transition ${
                    selectedDay === day
                      ? "bg-red-600 text-white shadow"
                      : "bg-gray-100 hover:bg-gray-200 text-gray-800"
                  }`}
                >
                  {day}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Pravý obsah */}
        <div className="w-full md:w-3/4 bg-white p-5 rounded-lg shadow-md border border-gray-200 min-h-[200px]">
          {isWeekend ? (
            <p className="text-center text-gray-600 text-lg my-10">
              Dnes denní menu nenabízíme.
            </p>
          ) : (
            <>
              <h3 className="text-xl font-bold text-orange-600 mb-3">Menu pro {selectedDay}</h3>
              <h4 className="text-lg font-bold text-red-800 mb-2">Hlavní jídla</h4>
              <ul className="list-disc list-inside space-y-1 text-sm text-gray-800 mb-6">
                {menuList.map((item, idx) => {
                  const [dish, price] = item.split("–");
                  return (
                    <li key={idx}>
                      {dish?.trim()}
                      {price && (
                        <>
                          {" – "}
                          <span className="font-semibold text-red-600">{price.trim()}</span>
                        </>
                      )}
                    </li>
                  );
                })}
              </ul>

              {sidesList.length > 0 && (
                <>
                  <h4 className="text-lg font-bold text-red-700 mb-2">Přílohy</h4>
                  <ul className="list-disc list-inside space-y-1 text-sm text-gray-800 mb-4">
                    {sidesList.map((item, idx) => (
                      <li key={`side-${idx}`}>{formatWithPriceHighlight(item)}</li>
                    ))}
                  </ul>
                </>
              )}

              {notesList.length > 0 && (
                <div className="space-y-1 text-sm text-gray-800 font-semibold">
                  {notesList.map((item, idx) => (
                    <p key={`note-${idx}`}>{formatWithPriceHighlight(item)}</p>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default DailyMenuTabs;